<template>
	<div class="search-form">
		<b-row align-h="between">
			<b-col cols="7">
				<b-form @reset="reset" onsubmit="return false">
					<b-input-group size="sm">
						<b-form-input
							@keyup.enter="query"
							type="search"
							v-model.trim="form.keyword"
							placeholder="导入模板名称/excel文件字段匹配方式/导入重复记录处理方式/模板文件原始名称搜索..."
						/>
						<b-input-group-append>
							<b-button-group>
								<b-button-group slot="reference">
									<b-button
										variant="link"
										size="sm"
										class="search-dropdown-button"
										squared
										@click="openAdvqueryDialog"
									>
										高级搜索
									</b-button>
									<b-button
										variant="primary"
										size="sm"
										@click="query"
									>
										<i class="fa fa-search" />
									</b-button>
								</b-button-group>
							</b-button-group>
						</b-input-group-append>
						<b-button
							v-allow="'actAdd'"
							size="sm"
							class="ml-2"
							variant="outline-success"
							@click="
								$emit('openEditFormDialog', { type: 'import' })
							"
						>
							<b-icon-plus></b-icon-plus>新增模板
						</b-button>
					</b-input-group>
				</b-form>
			</b-col>
		</b-row>

		<el-dialog
			title="高级搜索"
			:show-close="true"
			:visible.sync="advqueryDialogVisible"
			v-el-dialog-drag
			width="600px"
			:close-on-click-modal="false"
		>
			<el-form ref="form" :model="form">
				<el-row :gutter="20">
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="模板编号">
							<el-input
								v-model.trim="form.importTemplateNo"
								placeholder="请输入模板编号"
								clearable
								size="small"
							>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="模板类型">
							<el-input
								v-model.trim="form.importTemplateType"
								placeholder="请输入模板类型"
								clearable
								size="small"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="导入模板名称">
							<el-input
								v-model.trim="form.importTemplateName"
								placeholder="请输入扩展字段名称"
								clearable
								size="small"
							>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="模板文件原始名称">
							<el-input
								v-model.trim="form.importTemplateFileName"
								placeholder="请输入模板文件原始名称"
								clearable
								size="small"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="excel文件字段匹配方式">
							<dict-select
								filterable
								clearable
								v-model="form.excelMatchingMethod"
								placeholder="请选择匹配方式"
								default
								:body="{ type: 'excelMatchingMethod' }"
							/>
						</el-form-item>
					</el-col>

					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="导入重复记录处理方式">
							<dict-select
								filterable
								clearable
								v-model="form.ifRepeatMethod"
								placeholder="请选择导入重复记录处理方式"
								default
								:body="{ type: 'ifRepeatMethod' }"
							/>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="创建人名字">
							<el-input
								v-model.trim="form.createByName"
								placeholder="请输入创建人名字"
								clearable
								size="small"
							>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col
						:sm="{ span: 24 }"
						:md="{ span: 12 }"
						:lg="{ span: 12 }"
					>
						<el-form-item label="修改人名字">
							<el-input
								v-model.trim="form.modifyByName"
								placeholder="请输入修改人名字"
								clearable
								size="small"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row style="margin-top:10px">
					<el-form-item label="创建时间">
						<el-col
							:sm="{ span: 24 }"
							:md="{ span: 12 }"
							:lg="{ span: 10 }"
						>
							<el-date-picker
								v-model="form.createBeginDate"
								type="date"
								size="small"
								value-format="yyyy-MM-dd"
								placeholder="请选择创建时间"
								style="width: 100%"
							>
							</el-date-picker>
						</el-col>
						<el-col class="line" :span="1">-</el-col>
						<el-col
							:sm="{ span: 24 }"
							:md="{ span: 12 }"
							:lg="{ span: 10 }"
						>
							<el-date-picker
								v-model="form.createEndDate"
								type="date"
								size="small"
								value-format="yyyy-MM-dd"
								placeholder="请选择创建时间"
								style="width: 100%"
							>
							</el-date-picker>
						</el-col>
					</el-form-item>
				</el-row>

				<el-row style="margin-top:10px">
					<el-form-item label="修改时间">
						<el-col
							:sm="{ span: 24 }"
							:md="{ span: 12 }"
							:lg="{ span: 10 }"
						>
							<el-date-picker
								v-model="form.modifyBeginDate"
								type="date"
								size="small"
								value-format="yyyy-MM-dd"
								placeholder="请选择修改时间"
								style="width: 100%"
							>
							</el-date-picker>
						</el-col>
						<el-col class="line" :span="1">-</el-col>
						<el-col
							:sm="{ span: 24 }"
							:md="{ span: 12 }"
							:lg="{ span: 10 }"
						>
							<el-date-picker
								v-model="form.modifyEndDate"
								type="date"
								size="small"
								value-format="yyyy-MM-dd"
								placeholder="请选择修改时间"
								style="width: 100%"
							>
							</el-date-picker>
						</el-col>
					</el-form-item>
				</el-row>

				<el-row>
					<el-form-item label="模板状态">
						<el-checkbox-group
							v-model="form.importTemplateStatusList"
						>
							<el-checkbox label="Y">已启用</el-checkbox>
							<el-checkbox label="N">未启用</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-row>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeAdvqueryDialog"
					>取消查询</el-button
				>
				<el-button size="small" type="warning" @click="reset"
					>重置条件</el-button
				>
				<el-button size="small" type="primary" @click="advquery"
					>数据检索</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// 初始表单
const initForm = {
	keyword: '',
	importTemplateStatusList: ['Y'],
}

export default {
	data() {
		return {
			advqueryDialogVisible: false,
			form: { ...initForm },
		}
	},
	created() {
		this.query()
	},
	methods: {
		fromLoad(val) {
			this.$emit(val)
		},
		// 初始查询
		query({ isReset = true } = {}) {
			if (isReset) {
				this.$emit('reset')
			}
			this.$emit('query', this.form)
		},
		// 高级查询
		advquery() {
			this.form.keyword = ''
			this.query()
			this.closeAdvqueryDialog()
		},
		// 重置查询条件 - 高级查询
		reset() {
			this.form = { ...initForm }
		},
		// 打开高级查询
		openAdvqueryDialog() {
			this.advqueryDialogVisible = true
		},
		// 关闭高级查询
		closeAdvqueryDialog() {
			this.advqueryDialogVisible = false
		},
	},
}
</script>
<style lang="scss" scoped>
.el-form-item {
	margin-bottom: 0px;
}
.line {
	text-align: center;
}
</style>
